if (!customElements.get('wlsn-quantity-option')) {
  class WLSNQuantityOption extends HTMLElement {
    constructor() {
      super();

      this.classes = {};
      this.bindMethods = {
        handleClick: this._handleClick.bind(this),
        handleKeydown: this._handleKeydown.bind(this),
      };
    }

    get elements() {
      return {};
    }

    connectedCallback() {
      this.addEventListener('click', this.bindMethods.handleClick);
      this.addEventListener('keydown', this.bindMethods.handleKeydown);
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.bindMethods.handleClick);
      this.removeEventListener('keydown', this.bindMethods.handleKeydown);
    }

    _handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const { value, variantId } = this.dataset;
      if (value == null) return;
      this._setActive();
      this.dispatchEvent(
        new CustomEvent('wlsn:quantity-option:select', {
          bubbles: true,
          detail: { quantity: Number(value), variantId: variantId },
        })
      );
    }

    _setActive() {
      const container = this.closest('wlsn-quantity-options');
      if (!container) return;
      container.querySelectorAll('wlsn-quantity-option').forEach((el) => el.classList.remove('active'));
      this.classList.add('active');
    }

    _handleKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.bindMethods.handleClick(e);
      }
    }
  }
  customElements.define('wlsn-quantity-option', WLSNQuantityOption);
}

if (!customElements.get('wlsn-quantity-options')) {
  class WLSNQuantityOptions extends HTMLElement {
    constructor() {
      super();
      this._boundHandleQuantitySelect = this._handleQuantitySelect.bind(this);
    }

    get elements() {
      return {
        quantityInput: this.querySelector('input[name="quantity"]'),
        variantIdInput: this.closest('wlsn-product-form')?.querySelector('input[name="id"]'),
      };
    }

    connectedCallback() {
      this.addEventListener('wlsn:quantity-option:select', this._boundHandleQuantitySelect);
      this._syncFromActiveOptionOnLoad();
    }

    disconnectedCallback() {
      this.removeEventListener('wlsn:quantity-option:select', this._boundHandleQuantitySelect);
    }

    _syncFromActiveOptionOnLoad() {
      const activeOption = this.querySelector('wlsn-quantity-option.active');
      if (!activeOption) return;
      const { value, variantId } = activeOption.dataset;
      if (value == null || variantId == null) return;
      this._syncFromOption(Number(value), variantId);
    }

    _syncFromOption(quantity, variantId) {
      const { quantityInput, variantIdInput } = this.elements;
      if (!quantityInput || quantity == null || variantId == null) return;

      quantityInput.value = String(quantity);
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (variantIdInput) {
        variantIdInput.value = String(variantId);
        variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _handleQuantitySelect(e) {
      const { quantity, variantId } = e.detail || {};
      this._syncFromOption(quantity, variantId);
    }
  }
  customElements.define('wlsn-quantity-options', WLSNQuantityOptions);
}